import wixAnimations from 'wix-animations'
import { setMetaTags, metaTags } from 'wix-seo'

import sortBy from 'lodash/sortBy'
import orderBy from 'lodash/orderBy'
import wixData from 'wix-data'
import { local } from 'wix-storage'

export function sortCourses(courses, sortParameter) {
    switch (sortParameter) {
    case 'newestCourse':{
        // return sortBy(courses, ['createdDate'])
        const fixedUndefinedComingSoon = courses.map(course => {
            if (!course.comingSoon) course.comingSoon = false
            return course
        })
        return orderBy(fixedUndefinedComingSoon, ['comingSoon', 'createdDate'], ['asc', 'desc'])
    }
    case 'subjects':
        return sortBy(courses, [course => course.subjectTitle.toLowerCase()])
    case 'courseLength':
        return sortBy(courses, ['durationHours', 'durationMinutes'])
    default:
        return orderBy(courses, ['views'], ['desc']) // mostPopular
    }
}

export function sortTutorials(tutorials, sortParameter) {
    switch (sortParameter) {
    case 'newest':
        // return sortBy(tutorials, ['publishedDate'])
        return orderBy(tutorials, ['publishedDate'], ['desc'])
    case 'subjects':
        return sortBy(tutorials, [tutorial => tutorial.subjectTitle.toLowerCase()])
    case 'length':
        return sortBy(tutorials, ['durationMinutes', 'durationSeconds'])
    default:
        return orderBy(tutorials, ['views'], ['desc']) // mostPopular
    }
}

export function sortWebinars(webinars, sortParameter) {
    switch (sortParameter) {
    case 'newest':
        // return sortBy(webinars, ['recordingDate'])
        return orderBy(webinars, ['recordingDate'], ['desc'])
    case 'subjects':
        return sortBy(webinars, [webinar => webinar.subjectTitle.toLowerCase()])
        // case 'length':
        //     return sortBy(webinars, ['durationMinutes', 'durationSeconds'])
    default:
        return orderBy(webinars, ['views'], ['desc']) // mostPopular
    }
}

export function slideElementWithHeader(elementId) {
    if ($w('#headerLeaveViewportIndicator').onViewportLeave) {
        const slideUp = wixAnimations.timeline()
            .add($w(elementId), { // '#header, #footer, Section'
                duration: 300,
                y: -155,
                easing: 'easeLinear'
            })

        $w('#headerLeaveViewportIndicator').onViewportLeave(() => {
            slideUp.play()
        })

        $w('#headerEnterViewportIndicator').onViewportEnter(() => {
            slideUp.reverse()
        })
    }
}

const SUBJECTS_STORAGE_KEY = 'subjects'

export async function getSubjects() {

    const getSubjectsFromDb = () => wixData.query('subjects')
        .ascending('order')
        .find()
        .then(({ items: subjects }) => subjects)

    const updateSubjectsInLocalStorage = subjects => {
        const stringifiedSubjects = JSON.stringify(subjects)
        local.setItem(SUBJECTS_STORAGE_KEY, stringifiedSubjects)
    }

    const subjectsString = local.getItem(SUBJECTS_STORAGE_KEY)
    if (subjectsString) {
        getSubjectsFromDb().then(updateSubjectsInLocalStorage)
        return JSON.parse(subjectsString)
    } else {
        const subjects = await getSubjectsFromDb()
        updateSubjectsInLocalStorage(subjects)
        return subjects
    }
}

export async function getSubject(subjectId) {
    const subjects = await getSubjects()
    return subjects.find(subject => subject._id === subjectId)
}

export function subjectsToOptions(subjects) {
    return subjects.map(subjectItem => ({
        'label': subjectItem.title,
        'value': subjectItem._id
    }))
}

export function flattenCourses(courses, subject = {}) {
    const { _id: subjectId, title: subjectTitle, slug: subjectSlug } = subject

    return courses.map(course => Object.assign({}, course, {
        createdDate: course._createdDate,
        subjectTitle: subjectTitle || course.subject.title,
        numberOfClasses: course.classes.length,

        subjectId: subjectId || course.subject._id,
        subjectPageUrl: `/online-courses/${subjectSlug || course.subject.slug}`,
        // subjectPageUrl: course.subject['link-subjects-slug'],
        coursePageUrl: course['link-courses-1-title']
    }))
}

export function flattenTutorials(tutorials, subject = {}) {
    const { _id: subjectId, title: subjectTitle, slug: subjectSlug } = subject

    return tutorials.map(tutorial => Object.assign({}, tutorial, {
        subjectId: subjectId || tutorial.subject._id,
        subjectTitle: subjectTitle || tutorial.subject.title,
        subjectLink: `/tutorials/${subjectSlug || tutorial.subject.slug}`,
        // subjectLink: tutorial.subject['link-subjects-slug'],
        link: tutorial['link-tutorials-1-title']
    }))
}

export function flattenWebinars(webinars, subject = {}) {
    const { _id: subjectId, title: subjectTitle, slug: subjectSlug } = subject

    return webinars.map(webinar => Object.assign({}, webinar, {
        subjectId: subjectId || webinar.subject._id,
        subjectTitle: subjectTitle || webinar.subject.title,
        subjectLink: `/webinars/${subjectSlug || webinar.subject.slug}`,
        // subjectLink: webinar.subject['link-subjects-slug'],
        link: webinar['link-webinars-1-title']
    }))
}

export function setNoIndex() {
    setMetaTags([
        ...metaTags,
        { 'name': 'robots', 'content': 'noindex' }
    ])
}